import { render, staticRenderFns } from "./FormatTable.vue?vue&type=template&id=44fbdd2e&"
import script from "./FormatTable.vue?vue&type=script&lang=js&"
export * from "./FormatTable.vue?vue&type=script&lang=js&"
import style0 from "./FormatTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports